import { mapActions, mapGetters } from "vuex";
import Utils from '@/scripts/Utils';
import DiagnosticProposalService from '@/services/firebase/DiagnosticProposal/DiagnosticProposalService';
import UtilsProjects from "@/pages/Projects/Utils/Utils.js";
import ProjectsService from "@/services/server/ProjectsService.js";
import ProjectsFirebaseService from "@/services/firebase/Projects/ProjectService.js";
import LeadsService from "../../services/firebase/Leads/LeadsService";

import Prospecting from "@/components/Projects/Prospecting/Prospecting.vue"
import Diagnostic from "@/components/Projects/Diagnostic/Diagnostic.vue"
import Approval from "@/components/Projects/Approval/Approval.vue"
import Contract from "../../components/Projects/Contract/Contract.vue";
import Closing from "@/components/Projects/Closing/Closing.vue"
import Materials from "../../components/Projects/Materials/Materials.vue";
import Installation from "../../components/Projects/Installation/Installation.vue";
import UsersService from "@/services/firebase/Users/UsersService";
import UsersServiceBE from "@/services/server/UsersService";
import projectsService from "../../services/server/ProjectsService";
import IconContainer from '@/components/IconContainer.vue';
import {showErrorSnackBar, showSuccessSnackBar} from "../../utils/SnackBartHelper";
import NotificationReceptorConfig from '@/components/Projects/NotificationReceptorConfig.vue';
import NotificationReceptors from "../../components/Projects/NotificationReceptors.vue";
const ICONS = {
    info: 'mdi-information',
    warning: 'mdi-alert',
    error: 'mdi-alert-circle',
    success: 'mdi-check-circle',
}

export default {
    name: "ProjectDetail",

    components: {
        Prospecting,
        Diagnostic,
        Approval,
        Contract,
        Closing,
        Materials,
        Installation,
        IconContainer,
        NotificationReceptorConfig,
        NotificationReceptors,
    },

    data: () => ({
        notification_receptors_list: [],
        selected_notification_receptors: [],
        configDialog: false,
        currentReceptorConfig: null,
        configBackup: null, // Backup das configurações para restaurar ao fechar modal sem salvar
        configWasSaved: false, // Flag para indicar se as configurações foram salvas
        options: [
            {
                number: 1,
                name: UtilsProjects.STEPS.PROSPECTING,
                description: "Prospecção",
                color: "",
                icon: require("@/assets/projects/fz_magnify.png"),
                completed: false,
                isCurrentStep: false,
            },
            {
                number: 2,
                name: UtilsProjects.STEPS.DIAGNOSTIC,
                description: "Waterscan",
                color: "",
                icon: require("@/assets/projects/fz_waterscan.png"),
                completed: false,
                isCurrentStep: false,
            },
            {
                number: 3,
                name: UtilsProjects.STEPS.APPROVAL,
                description: "Aprovação",
                color: "#182b57",
                icon: require("@/assets/projects/fz_approval.png"),
                completed: false,
                isCurrentStep: false,
            },
            {
                number: 4,
                name: UtilsProjects.STEPS.CLOSING,
                description: "Fechamento",
                color: "",
                icon: require("@/assets/projects/fz_deal.png"),
                completed: false,
                isCurrentStep: false,
            },
            {
                number: 5,
                name: UtilsProjects.STEPS.CONTRACTS,
                description: "Contratos",
                color: "#182b57",
                icon: require("@/assets/projects/fz_docs.png"),
                completed: false,
                isCurrentStep: false,
            },
            {
                number: 6,
                name: UtilsProjects.STEPS.MATERIALS,
                description: "Entrega",
                color: "#182b57",
                icon: require("@/assets/projects/fz_shipping.png"),
                completed: false,
                isCurrentStep: false,
            },
            {
                number: 7,
                name: UtilsProjects.STEPS.INSTALLATION,
                description: "Waterfix",
                color: "",
                icon: require("@/assets/projects/fz_waterfix.png"),
                completed: false,
                isCurrentStep: false,
            },
        ],
        openProspection: false,
        openDiagnostic: false,
        openApproval: false,
        openClosing: false,
        openContract: false,
        openMaterials: false,
        openInstallation: false,
        is_loading: true,
        saving_configs_loading: false,
        is_created: false,
        has_error: false,
        modal: false,
        tab: 0,
        tabItems: [],
        project_franchisee_list: [],
        form: {
			franchisee_name: null,
			id_franchisee: null,
		},
        project: {
            id_lead: null,
            id_doc: null,
            configs: {
                wpp_notification: true,
                notification_receptors: [],
            }
        },
        isOnline: navigator.onLine,
        items: [],
    }),

    computed: {
         ...mapGetters([ "getCurrentUserRank" ]),
        currentStep() {
            return this.project.steps.find(
              step => step.isCurrentStep
            ).name;
        },
        changeColSize(){
            return this.getCurrentUserRank === "Franqueado"? 6 : 4
        }
    },

    methods: {
        goBack() {
			this.$router.back(); 
		},
        async openModalLog(){
            const logList = await ProjectsFirebaseService.getProjectLog(this.project.id_doc)
            const iconMap = {
                info: ICONS.info,
                warning: ICONS.warning,
                success: ICONS.success,
              };
            this.items = logList.map((log) => ({
                ...log,
                stepName: UtilsProjects.TranslateSteps[log.stepName],
                date: Utils.formatDate( new Date(log.createdAt.seconds * 1000), '<dd>/<MM>/<YYYY> as <HH>:<mm>'),
                icon: iconMap[log.type] || null, 
            }));
            this.modal = true
        },

        isDisabled(step) {
            return !step.completed && !step.isCurrentStep;
        },
        openStep(step) {
            switch (step) {
                case UtilsProjects.STEPS.PROSPECTING: return this.openProspection = true
                case UtilsProjects.STEPS.DIAGNOSTIC: return this.openDiagnostic = true
                case UtilsProjects.STEPS.APPROVAL: return this.openApproval = true
                case UtilsProjects.STEPS.CLOSING: return this.openClosing = true
                case UtilsProjects.STEPS.CONTRACTS: return this.openContract = true
                case UtilsProjects.STEPS.MATERIALS: return this.openMaterials = true
                case UtilsProjects.STEPS.INSTALLATION: return this.openInstallation = true
                default:
                    break;
            }
        },
        closeFunc(type) {
            this.getProject();
            switch (type) {
                case UtilsProjects.STEPS.PROSPECTING: return this.openProspection = false
                case UtilsProjects.STEPS.DIAGNOSTIC: return this.openDiagnostic = false
                case UtilsProjects.STEPS.APPROVAL: return this.openApproval = false
                case UtilsProjects.STEPS.CLOSING: return this.openClosing = false
                case UtilsProjects.STEPS.CONTRACTS: return this.openContract = false
                case UtilsProjects.STEPS.MATERIALS: return this.openMaterials = false
                case UtilsProjects.STEPS.INSTALLATION: return this.openInstallation = false
                default:
                    break;
            }
        },
        checkId(id_name) {
            return this.project.hasOwnProperty(id_name)
        },
        isCompleted(step_name) {
            let index = this.options.findIndex((option) => option.name == step_name)
            if (index < 0) return true
            return this.options[index].completed
        },
        async getProject() {
            this.is_loading = true
            let [status, project] = await ProjectsService.getProjectById(this.$route.params.id)
            if (!status) this.has_error = true
            else {
                const responseFranchise = await UsersService.getUsersById(project.id_franchisee)
                const responseLead = await LeadsService.getLeadsById(project.id_lead)
                let created_at = new Date(project.created_at._seconds * 1000)
                this.project = {
                    ...project,
                    created_at,
                    configs: {
                        ...project.configs,
                        wpp_notification: project.configs ? project.configs.wpp_notification : true,
                        notification_receptors: project.configs?.notification_receptors || [],
                    },
                    franchisee_name_formatted: responseFranchise? responseFranchise.name : "Indefinido!",
                    created_at_formatted: Utils.formatDate(created_at, '<dd>/<MM>/<YYYY>'),
                    registration: responseLead.registration === null ? "Não informado" : responseLead.registration
                }
                // Carrega IDs dos receptores para o autocomplete
                this.selected_notification_receptors = (this.project.configs.notification_receptors || [])
                    .map(receptor => receptor.id)
                this.updateSteps(this.project.steps)
                await this.waterScarnRevision()
            }
            this.is_loading = false
        },
        async updateProjectConfigs () {
            this.saving_configs_loading = true
            await projectsService.updateProject(this.project.id_doc, { configs: this.project.configs })
                .then((r) => {
                    showSuccessSnackBar("Configurações Salvas com sucesso!");
                    const status = this.project.configs.wpp_notification ? 'Ativado' : 'Desativado';
                    UtilsProjects.createInfoLog(this.project.id_doc, UtilsProjects.STEPS.NOTIFICATIONS, status, UtilsProjects.STEPS.OUT);
                })
                .catch((err) => {
                    console.error(err);
                    showErrorSnackBar("Aconteceu um erro inesperado, contacte o suporte técnico!")
                }).finally(
                    () => {
                        this.saving_configs_loading = false
                        this.modal = false
                    }
                )
        },
        updateSteps(steps) {
            if (steps) {
                steps.forEach(({ name, isCurrentStep, completed }) => {
                    const option = this.options.find(option => option.name === name);
                    if (option) {
                        Object.assign(option, { isCurrentStep, completed });
                    }
                });
            }
        },
        updateOnlineStatus() {
            this.isOnline = navigator.onLine;
            if (!this.isOnline) alert("Você está offline. Suas alterações serão sincronizadas quando a conexão retornar.");
        },
        async waterScarnRevision(){
            try {
                if(this.options[1].isCurrentStep){
                    const isRevision = await DiagnosticProposalService.getWaterScanProposalByDiagnosticId(this.project.id_diagnostic)
                    isRevision.forEach(revision => {
                        if(this.getCurrentUserRank === "Super Admin" || this.getCurrentUserRank === "Admin"  && revision.revision.status === "revision"){
                            this.options[2].isCurrentStep = true
                        }
                    });
                }
            } catch (error) {
                console.error("Erro ao verificar revisão do WaterScan:", error);
                showErrorSnackBar("Erro ao verificar status da revisão do WaterScan");
            }
        },
        async getAllFranchisee(){
            const response = await UsersServiceBE.findAllFranchisee()
            this.project_franchisee_list = []

            if (response.status == 200) {
                this.franchisee_list = [
                    {
                        id: 'general',
                        name: 'Geral',
                    },
                    ...response.data.data
                ]
                this.project_franchisee_list = response.data.data.map(franchisee => ({
                    ...franchisee,
                    text: franchisee.name,
                    value: franchisee.id
                }))
                
                // Set initial form values if project has franchisee_id
                if (this.project.id_franchisee) {
                    const selectedFranchisee = this.project_franchisee_list.find(f => f.id === this.project.id_franchisee)
                    if (selectedFranchisee) {
                        this.form.id_franchisee = selectedFranchisee.id
                        this.form.franchisee_name = selectedFranchisee.name
                    }
                }
            } else {
                showErrorSnackBar("Ocorreu um erro na busca da lista de franqueados")
            }
        },
        handleFranchiseeChange(selectedFranchisee) {
            if (selectedFranchisee) {
                this.form.id_franchisee = selectedFranchisee.id
                this.form.franchisee_name = selectedFranchisee.name
            } else {
                this.form.id_franchisee = null
                this.form.franchisee_name = null
            }
        },
        async changeFrachiseeProject(){
            this.saving_configs_loading = true
            await ProjectsService.updateProject(this.project.id_doc,{id_franchisee: this.form.id_franchisee})
                .then((r) => {
                    this.project.franchisee_name_formatted = this.form.franchisee_name
                    showSuccessSnackBar("Configurações Salvas com sucesso!");
                })
                .catch((err) => {
                    console.error(err);
                    showErrorSnackBar("Aconteceu um erro inesperado, contacte o suporte técnico!")
                }).finally(
                    () => {
                        this.saving_configs_loading = false
                        this.modal = false
                    }
                )
        },
    
        async getNotificationReceptors() {
            try {
                const allUsers = [];
                const users = await UsersService.getUsers();
            
                if (users && users.length > 0) {
                    allUsers.push(...users);
                }                
                
                this.notification_receptors_list = allUsers.map(user => ({
                    id: user.id,
                    name: user.name,
                    phone: user.phone,
                    rank: user.rank,
                    text: `${user.name} `,
                    value: user.id
                }));
            } catch (error) {
                showErrorSnackBar("Erro ao carregar lista de receptores");
            }
        },

        openReceptorConfig(receptorId) {
            const receptor = this.notification_receptors_list.find(r => r.id === receptorId);
            if (!receptor) {
                showErrorSnackBar('Receptor não encontrado');
                return;
            }

            // Busca a configuração atual do receptor ou cria uma nova com todos os status
            const currentConfig = this.project.configs.notification_receptors
                ? this.project.configs.notification_receptors.find(r => r.id === receptorId)
                : null;
            
            this.currentReceptorConfig = {
                id: receptorId,
                name: receptor.name,
                statuses: (currentConfig && currentConfig.statuses) ? currentConfig.statuses : [],
            };

            this.configDialog = true;
        },

        saveReceptorConfig(config) {
            const { receptorId, statuses } = config;
            
            // Atualiza ou adiciona a configuração do receptor
            const receptorIndex = this.project.configs.notification_receptors.findIndex(
                r => r.id === receptorId
            );

            if (receptorIndex >= 0) {
                // Atualiza configuração existente
                this.project.configs.notification_receptors[receptorIndex].statuses = statuses;
            } else {
                // Adiciona nova configuração
                this.project.configs.notification_receptors.push({
                    id: receptorId,
                    statuses,
                });
            }

            showSuccessSnackBar('Configuração de alertas salva com sucesso!');
        },

        getReceptorById(receptorId) {
            return this.notification_receptors_list.find(r => r.id === receptorId) || null;
        },

        getReceptorAlertsCount(receptorId) {
            if (!this.project.configs.notification_receptors) {
                return 0;
            }
            const receptor = this.project.configs.notification_receptors.find(r => r.id === receptorId);
            if (receptor && receptor.statuses) {
                return receptor.statuses.length;
            }
            return 0;
        },

        /**
         * Remove um receptor da lista de selecionados
         * @param {string} receptorId - ID do receptor a ser removido
         */
        removeReceptor(receptorId) {
            const index = this.selected_notification_receptors.indexOf(receptorId);
            if (index > -1) {
                this.selected_notification_receptors.splice(index, 1);
            }
        },

        /**
         * Salva a lista de receptores de notificação
         * Mantém as configurações de alertas dos receptores existentes
         * Adiciona novos receptores com todos os alertas habilitados por padrão
         */
        async saveNotificationReceptors() {
            // Validações
            if (this.selected_notification_receptors.length === 0) {
                // Remove todos os receptores se nenhum está selecionado
                const updatedConfigs = { ...this.project.configs };
                delete updatedConfigs.notification_receptors;
                
                this.saving_configs_loading = true;
                await projectsService.updateProject(this.project.id_doc, { configs: updatedConfigs })
                    .then(() => {
                        this.project.configs = updatedConfigs;
                        showSuccessSnackBar("Receptores de notificação removidos com sucesso!");
                    })
                    .catch((err) => {
                        console.error(err);
                        showErrorSnackBar("Aconteceu um erro inesperado, contacte o suporte técnico!");
                    })
                    .finally(() => {
                        this.saving_configs_loading = false;
                        this.configWasSaved = true;
                        this.modal = false;
                    });
                return;
            }

            if (this.selected_notification_receptors.length > 10) {
                showErrorSnackBar("Máximo de 10 receptores permitidos");
                return;
            }
            
            this.saving_configs_loading = true;
            
            // Mantém as configurações existentes e adiciona novos receptores
            const currentReceptors = this.project.configs.notification_receptors || [];

            const receptorsData = this.selected_notification_receptors.map(id => {
                // Verifica se o receptor já tem configuração
                const existingConfig = currentReceptors.find(r => r.id === id);
                
                if (existingConfig) {
                    // Mantém a configuração existente
                    return existingConfig;
                } else {
                    // Novo receptor: todos os alertas desabilitados por padrão (array vazio)
                    return {
                        id,
                        statuses: [],
                    };
                }
            });
            
            this.project.configs.notification_receptors = receptorsData;
            
            await projectsService.updateProject(this.project.id_doc, { 
                configs: this.project.configs 
            })
                .then(() => {
                    showSuccessSnackBar("Receptores de notificação salvos com sucesso!");
                })
                .catch((err) => {
                    console.error(err);
                    showErrorSnackBar("Aconteceu um erro inesperado, contacte o suporte técnico!");
                })
                .finally(() => {
                    this.saving_configs_loading = false;
                    this.configWasSaved = true;
                    this.modal = false;
                });
        },
    },
    mounted() {
        window.addEventListener("online", this.updateOnlineStatus);
        window.addEventListener("offline", this.updateOnlineStatus);
    },
    beforeDestroy() {
        window.removeEventListener("online", this.updateOnlineStatus);
        window.removeEventListener("offline", this.updateOnlineStatus);
    },
    watch: {
        modal(newValue, oldValue) {
            if (newValue && !oldValue) {
                // Modal abriu - cria backup das configurações e reseta flag
                this.configWasSaved = false;
                this.configBackup = JSON.parse(JSON.stringify({
                    notification_receptors: this.project.configs.notification_receptors || [],
                    selected_ids: [...this.selected_notification_receptors]
                }));
            } else if (!newValue && oldValue && !this.configWasSaved) {
                // Modal fechou SEM salvar - restaura do backup
                if (this.configBackup) {
                    this.project.configs.notification_receptors = JSON.parse(JSON.stringify(this.configBackup.notification_receptors));
                    this.selected_notification_receptors = [...this.configBackup.selected_ids];
                    this.configBackup = null;
                }
            } else if (!newValue && oldValue && this.configWasSaved) {
                // Modal fechou DEPOIS de salvar - apenas limpa o backup
                this.configBackup = null;
                this.configWasSaved = false;
            }
        }
    },
    async created() {
        await this.getProject()
        await this.getAllFranchisee()
        await this.getNotificationReceptors()
        this.getCurrentUserRank === "Franqueado"? this.tabItems=['Notificações', 'Log'] : this.tabItems=['Notificações', 'Log', "Responsável", "Notificação personalizada"]
        this.is_created = true
    },
};